import { getIcon } from "~/util/providers/poiagg";

export function getSignIcon(typeId: number) {
	const icon = getIcon(typeId) as string;
	let srcset = "";

	if (icon) {
		const icon2x = getIcon(typeId, { scale: 2 });

		if (icon2x) {
			srcset = `${icon} 1x${icon2x ? `, ${icon2x} 2x` : ""}`;
		}
	}

	return {
		icon: icon || undefined,
		srcset: srcset || undefined,
	};
}
